import React from 'react';
import CommonProductSelection from 'src/constrains/AdvancedFilters/Components/CommonProductSelection';

const ProductsInShoppingCart = (props) => {
  const { noStyle, radioName } = props;
  return <CommonProductSelection noStyle={noStyle} radioName={radioName} />;
};
export default ProductsInShoppingCart;
